// src/sections/Landing.js
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const WORKER_URL = "https://reflex-backend.alfaoir1.workers.dev";

const slides = [
  {
    quote: "I highly recommend working with this creative team who listened to all my needs and delivered excellent results. They were efficient, detail oriented and had great communication!",
    avatar: "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/62cfdef7-3241-4433-b0cf-89e4658a6c43.jfif",
    name: "Dmitri O.",
    role: "CEO",
    company: "Toronto Junk Disposal",
    website: "https://torontjunkdisposal.online",
    initials: null,
  },
  {
    quote: "They are so professional and so good at hitting all the right points that you probably didn't even consider. Strongly recommend to all businesses, small or large. Amazing job!",
    avatar: "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/andrew.jfif",
    name: "Andrew S.",
    role: "Operational Manager",
    company: "MDS Mini Bins",
    website: "https://mdsminibins.com",
    initials: null,
  },
];


export default function Landing() {
  const [tsCur, setTsCur] = useState(0);
  const navigate = useNavigate();
  const [isOfferModalOpen, setIsOfferModalOpen] = useState(false);
  const [offerSubmitting, setOfferSubmitting] = useState(false);
  const [offerForm, setOfferForm] = useState({
    name: "",
    phone: "",
    email: "",
    company: "",
    website: "",
    note: "",
  });

  const handleOfferChange = (e) => {
    const { name, value } = e.target;
    setOfferForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleOfferSubmit = async (e) => {
    e.preventDefault();
    if (!offerForm.name.trim() || !offerForm.email.trim() || !offerForm.phone.trim()) {
      alert("Please fill in your name, phone, and email before continuing.");
      return;
    }
    setOfferSubmitting(true);
    try {
      const res = await fetch(`${WORKER_URL}/offer-form`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(offerForm),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error || "Unknown error");
      // Redirect to Stripe payment only after a successful save
      window.location.href = "https://links.equiptbiz.com/payment-link/6a392e807a7ef176dee582f4";
    } catch (err) {
      console.error(err);
      alert("Something went wrong saving your details. Please try again.");
    } finally {
      setOfferSubmitting(false);
    }
  };

  const tsPrev = () => setTsCur((c) => (c - 1 + slides.length) % slides.length);
  const tsNext = () => setTsCur((c) => (c + 1) % slides.length);
  const s = slides[tsCur];

  return (
    <React.Fragment>

{/* Hero SECTION */}
      <section className="landing-section">

        {/* SEO */}
        <Helmet>
  <title>Reflex Advisor | Lead Gen & Automation for Service Businesses</title>
  <meta name="description" content="Reflex Advisor delivers done-for-you lead generation and sales automation for service-based businesses — powered by Human + AI to drive real revenue growth." />
  <meta name="keywords" content="lead generation automation, service business growth, GHL automation, human AI lead gen, service company marketing, appointment setting, sales automation" />
  <script type="application/ld+json">{`
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Reflex Advisor",
    "@id": "https://reflexadvisor.com/#organization",
    "url": "https://reflexadvisor.com",
    "owns": [
      { "@type": "Organization", "name": "Reflex Junk", "url": "https://reflexjunk.online" },
      { "@type": "Organization", "name": "Reflex Roofer", "url": "https://reflexroofer.online" }
    ]
  }
  `}</script>
  <style>{`
    html, body {
      margin: 0;
      padding: 0;
      overflow-x: hidden;
      background: #000;
      color: #ffffff;
      font-size: 16px;
    }
  `}</style>
</Helmet>

        {/* Background Video */}
        <video
          className="landing-bg-video"
          autoPlay
          loop
          muted
          playsInline
        >
          <source
            src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/videos/landingvideo.mp4"
            type="video/mp4"
          />
        </video>

        {/* Subtle dark overlay for readability */}
        <div className="landing-overlay" />

        {/* Content */}
        <div className="landing-content">

          <h1 className="landing-heading">
          Scaling Service Businesses By
          <br />
          <span className="animated-highlight">$10K-$30K/Month</span>
          </h1>

          <p className="landing-para">
We help service based companies land high-paying contracts and hit six figures in 90 days , you just show up, we handle everything else.</p>

          <div className="cta-row">
            <a href="/booking" className="cta-button">
  Claim My Free Strategy Call
</a>
          </div>
        </div>

        <style>{`
          :root {
            --color-dark: #000;
            --color-white: #fff;
            --color-primary: #7b19bc;
            --color-primary-light: #d18cf3;
            --font-display: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
            --font-body: -apple-system, 'SF Pro Text', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
          }

          .landing-section {
            position: relative;
            background-color: var(--color-dark);
            color: var(--color-white);
            min-height: 100vh;
            min-height: 100dvh;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            text-align: center;
            overflow: hidden;
            box-sizing: border-box;
            width: 100%;
            padding: 120px 24px 100px;
            font-family: var(--font-body);
          }

          .landing-bg-video {
            position: absolute;
            top: 0; left: 0;
            width: 100%; height: 100%;
            object-fit: cover;
            z-index: 0;
            opacity: 0.28;
          }

          .landing-overlay {
            position: absolute;
            inset: 0;
            z-index: 1;
            background: linear-gradient(
              to bottom,
              rgba(0,0,0,0.15) 0%,
              rgba(0,0,0,0.0) 40%,
              rgba(0,0,0,0.55) 100%
            );
            pointer-events: none;
          }

          .landing-content {
            position: relative;
            z-index: 2;
            max-width: 750px;
            width: 100%;
            box-sizing: border-box;
            padding: 0 16px;
            animation: fadeUp 1s ease both;
          }

          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(28px); }
            to   { opacity: 1; transform: translateY(0); }
          }

          .landing-heading {
            font-family: var(--font-display);
            font-size: 52px;
            font-weight: 700;
            line-height: 1.1;
            letter-spacing: -0.03em;
            margin: 0 0 28px;
            color: var(--color-white);
            word-break: break-word;
            animation: fadeUp 1s ease 0.2s both;
          }

          .animated-highlight {
            background: linear-gradient(90deg, #ffffff, #c084fc, #a855f7, #7b19bc, #a855f7, #c084fc, #ffffff);
            background-size: 300% auto;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            animation: shimmer 4s linear infinite;
          }

          @keyframes shimmer {
            0%   { background-position: 0% center; }
            100% { background-position: 300% center; }
          }

          .landing-para {
           font-family: var(--font-body);
           font-size: 18px;
           font-weight: 400;
           color: rgba(255,255,255,1);
           line-height: 1.65;
           max-width: 640px;
           margin: 0 auto 40px;
           letter-spacing: 0.01em;
           animation: fadeUp 1s ease 0.35s both;
          }

          .cta-row {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 20px;
            flex-wrap: wrap;
            animation: fadeUp 1s ease 0.5s both;
          }

          .cta-button {
            padding: 14px 32px;
            font-family: var(--font-display);
            font-size: 15px;
            font-weight: 600;
            letter-spacing: 0.01em;
            cursor: pointer;
            background: #ffffff;
            color: #7b19bc;
            border: 2px solid #7b19bc;
            border-radius: 980px;
            transition: background 0.25s ease, color 0.25s ease, border-color 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
          }

          .cta-button:hover {
            background: var(--color-primary);
            color: #ffffff;
            border-color: transparent;
            transform: translateY(-2px);
            box-shadow:
              0 0 0 4px rgba(123, 25, 188, 0.15),
              0 0 24px rgba(168, 85, 247, 0.5),
              0 8px 32px rgba(123, 25, 188, 0.35);
          }

          .cta-ghost {
            font-family: var(--font-display);
            font-size: 15px;
            font-weight: 500;
            color: rgba(255,255,255,0.65);
            text-decoration: none;
            letter-spacing: 0.01em;
            transition: color 0.2s ease;
            border-bottom: 1px solid rgba(255,255,255,0.2);
            padding-bottom: 2px;
          }

          .cta-ghost:hover {
            color: rgba(255,255,255,1);
            border-bottom-color: rgba(255,255,255,0.6);
          }

          .modal-backdrop {
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.75);
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 999;
          }

         .modal-inner {
  position: relative;
  width: 95%;
  max-width: 900px;
  height: 90vh;
  background: #1a1a1a;
  border-radius: 18px;
  padding: 40px 24px 24px;
  box-shadow: 0 32px 80px rgba(0,0,0,0.6);
  display: flex;
  flex-direction: column;
}

          .modal-close {
            position: absolute;
            top: 12px;
            right: 14px;
            background: rgba(255,255,255,0.1);
            color: #fff;
            border: none;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            font-size: 14px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background 0.2s ease;
          }

          .modal-close:hover {
            background: rgba(255,255,255,0.22);
          }

          @media (max-width: 1024px) {
            .landing-heading { font-size: 42px; }
          }
          @media (max-width: 768px) {
            .landing-section { padding: 100px 20px 80px; }
            .landing-heading { font-size: 32px; letter-spacing: -0.02em; }
            .landing-para { font-size: 16px; }
            .cta-button { width: 100%; max-width: 280px; }
            .cta-row { flex-direction: column; gap: 14px; }
          }
          @media (max-width: 480px) {
            .landing-heading { font-size: 26px; }
            .eyebrow { font-size: 11px; }
            .landing-para { font-size: 15px; }
          }
        `}</style>
      </section>

{/* REFLEX ADVISOR — SOFTWARE COMPANIES SECTION */}
<div className="ra2-wrap">
  <div className="ra2-inner">

    {/* DIV 1 — Hero Section */}
    <div className="ra2-div1">
      <div className="ra2-tag">Reflex Advisor</div>
      <div className="ra2-badge">Built For Software Companies</div>
      
      <h1 className="ra2-h1">
        We Get You<br />
        <span className="ra2-highlight">Paying Clients.</span>
      </h1>
      
      <p className="ra2-sub1">We find companies that need what you sell, contact them every day, and book meetings on your calendar. You just show up and close.</p>
      
      <div className="ra2-btn-row">
  <Link to="/softwarecompanies" className="ra2-btn">View Details →</Link>
</div>
    </div>

  </div>

  <style>{`
    .ra2-wrap {
      --white: #FFFFFF;
      --black: #0A0A0A;
      --red: #FF3B30;
      --grey: rgba(0,0,0,0.72);
      --font-display: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      --font-body: -apple-system, 'SF Pro Text', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      background: var(--white);
      color: var(--black);
      font-family: var(--font-body);
      padding: 96px 32px 80px;
      -webkit-font-smoothing: antialiased;
      box-sizing: border-box;
    }
    .ra2-wrap *, .ra2-wrap *::before, .ra2-wrap *::after {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }
    .ra2-inner {
      max-width: 900px;
      margin: 0 auto;
    }
    .ra2-div1 {
      margin-bottom: 64px;
    }
    .ra2-tag {
      font-family: var(--font-display);
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      color: var(--red);
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .ra2-tag::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      background: var(--red);
      border-radius: 50%;
    }
    .ra2-badge {
      display: inline-block;
      background: var(--black);
      color: var(--white);
      padding: 10px 16px;
      font-family: var(--font-display);
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      margin-bottom: 32px;
      border-radius: 4px;
    }
    .ra2-h1 {
      font-family: var(--font-display);
      font-size: 90px;
      font-weight: 900;
      line-height: 1.05;
      letter-spacing: -0.03em;
      color: var(--black);
      margin-bottom: 24px;
      max-width: 720px;
    }
    .ra2-highlight {
      color: var(--red);
      background: linear-gradient(90deg, #FF3B30, #FF7A30);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .ra2-sub1 {
      font-family: var(--font-body);
      font-size: 18px;
      font-weight: 400;
      line-height: 1.65;
      color: var(--grey);
      max-width: 520px;
      margin-bottom: 52px;
      letter-spacing: 0.01em;
    }
    .ra2-btn-row {
      margin-top: 36px;
    }
    .ra2-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 14px 32px;
      background: #0A0A0A;
      color: #ffffff;
      font-family: var(--font-display);
      font-size: 16px;
      font-weight: 600;
      border-radius: 980px;
      text-decoration: none;
      transition: background 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
      box-shadow: 0 1px 2px rgba(0,0,0,0.15);
    }
    .ra2-btn:hover {
      background: #2a2a2a;
      transform: translateY(-2px);
      box-shadow: 0 8px 28px rgba(0,0,0,0.35);
    }
    @media (max-width: 1024px) {
      .ra2-h1 { font-size: 52px; }
    }
    @media (max-width: 768px) {
      .ra2-h1 { font-size: 38px; letter-spacing: -0.02em; }
      .ra2-sub1 { font-size: 16px; }
      .ra2-badge { margin-bottom: 24px; }
    }
    @media (max-width: 480px) {
      .ra2-h1 { font-size: 30px; }
      .ra2-sub1 { font-size: 15px; }
      .ra2-btn { width: 100%; justify-content: center; padding: 12px 24px; font-size: 15px; }
      .ra2-badge { font-size: 10px; padding: 8px 12px; }
    }
  `}</style>
</div>


{/* AI DESK MANAGER SECTION */}
<div className="adm-wrap" id="ai-desk-manager">
  <div className="adm-inner">

    <div className="adm-left">
      <p className="adm-eyebrow">AI Desk Manager™️</p>
      <h2 className="adm-headline">
        Your 24/7 Front Desk Agent
      </h2>
      <p className="adm-sub">
        Answers every call, qualifies leads, books appointments, and sends you everything automatically. So even if you're busy or asleep, nothing gets missed.
      </p>

      <a href="/aideskmanager" className="adm-btn">See How It Works →</a>
    </div>

  </div>

  <style>{`
    .adm-wrap {
      background-image: url('https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/aibg2.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      color: #fff;
      font-family: -apple-system, 'SF Pro Text', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      min-height: 720px;
      display: flex;
      align-items: center;
    }
    .adm-inner {
      position: relative;
      z-index: 2;
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      padding: 90px 40px;
      display: flex;
      justify-content: flex-start;
      box-sizing: border-box;
    }
    .adm-left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      gap: 18px;
      max-width: 560px;
    }
    .adm-eyebrow {
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.2em;
      text-transform: uppercase;
      color: #fff;
      margin: 0;
    }
    .adm-headline {
      font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      font-size: 44px;
      font-weight: 700;
      letter-spacing: -0.03em;
      line-height: 1.12;
      color: #fff;
      margin: 0;
    }
    .adm-sub {
      font-size: 16px;
      color: rgba(255,255,255,0.85);
      line-height: 1.7;
      margin: 0;
      max-width: 480px;
    }
    .adm-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      margin-top: 12px;
      padding: 14px 32px;
      background: #fff;
      color: #0a0a0a;
      font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      font-size: 16px;
      font-weight: 600;
      border-radius: 980px;
      text-decoration: none;
      transition: background 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
    }
    .adm-btn:hover {
      background: #f0f0f0;
      transform: translateY(-2px);
      box-shadow: 0 8px 28px rgba(0,0,0,0.35);
    }
    @media (max-width: 1024px) {
      .adm-inner { padding: 72px 32px; }
      .adm-headline { font-size: 36px; }
    }
    @media (max-width: 768px) {
      .adm-wrap { min-height: 620px; }
      .adm-inner { padding: 56px 24px; }
      .adm-left { max-width: 100%; }
      .adm-headline { font-size: 28px; }
      .adm-sub { max-width: 100%; }
    }
    @media (max-width: 480px) {
      .adm-wrap { min-height: 560px; }
      .adm-inner { padding: 48px 20px; }
      .adm-headline { font-size: 24px; }
      .adm-btn { width: 100%; justify-content: center; }
    }
  `}</style>
</div>


{/* COMMERCIAL ACQUISITION SECTION */}
<div className="cas-section" id="client-acquisition">
  <div className="cas-inner">

    <div className="cas-left">
      <h2 className="cas-headline">Commercial Acquisition System</h2>
      <p className="cas-tagline">Turning Property Managers, Contractors & Real Estate Agents into Paying Clients Fast</p>
      <p className="cas-sub">Open your inbox to new junk removal contracts daily</p>
      <a href="/pricing" className="cas-btn">View Details →</a>
    </div>

    <div className="cas-right">
      <img
        src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/images_girl.png"
        alt="Commercial Acquisition System"
        className="cas-img"
      />
    </div>

  </div>

  <style>{`
    .cas-section {
      background: #ffffff;
      border-top: 1px solid #f0eaf8;
      font-family: -apple-system, 'SF Pro Text', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      box-sizing: border-box;
    }
    .cas-inner {
      max-width: 1100px;
      margin: 0 auto;
      padding: 64px 40px;
      display: flex;
      align-items: center;
      gap: 56px;
      box-sizing: border-box;
    }
    .cas-left {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }
    .cas-headline {
      font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      font-size: 38px;
      font-weight: 800;
      letter-spacing: -0.035em;
      line-height: 1.08;
      color: #0a0a0a;
      margin: 0;
    }
    .cas-tagline {
      font-size: 18px;
      font-weight: 500;
      color: #0a0a0a;
      letter-spacing: -0.01em;
      line-height: 1.5;
      margin: 0;
    }
    .cas-sub {
      font-size: 16px;
      color: #666;
      line-height: 1.6;
      margin: 0;
    }
    .cas-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      margin-top: 8px;
      padding: 14px 32px;
      background: #7b19bc;
      color: #fff;
      font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      font-size: 16px;
      font-weight: 600;
      border-radius: 980px;
      text-decoration: none;
      transition: background 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
      box-shadow: 0 1px 2px rgba(0,0,0,0.15);
    }
    .cas-btn:hover {
      background: #9b24e8;
      transform: translateY(-2px);
      box-shadow: 0 8px 28px rgba(123,25,188,0.45);
    }
    .cas-right {
      flex: 1;
      max-width: 420px;
    }
    .cas-img {
      width: 100%;
      height: auto;
      display: block;
      border-radius: 20px;
    }
    @media (max-width: 1024px) {
      .cas-inner { padding: 56px 32px; gap: 40px; }
      .cas-headline { font-size: 34px; }
      .cas-tagline { font-size: 17px; }
    }
    @media (max-width: 768px) {
      .cas-inner {
        flex-direction: column-reverse;
        padding: 48px 24px;
        gap: 28px;
      }
      .cas-right {
        max-width: 320px;
        width: 100%;
      }
      .cas-left {
        align-items: center;
        text-align: center;
      }
      .cas-headline { font-size: 26px; }
      .cas-tagline { font-size: 16px; }
      .cas-sub { font-size: 14px; }
    }
    @media (max-width: 480px) {
      .cas-inner { padding: 40px 20px; gap: 24px; }
      .cas-right { max-width: 260px; }
      .cas-headline { font-size: 22px; }
      .cas-tagline { font-size: 15px; }
      .cas-btn { width: 100%; justify-content: center; padding: 12px 24px; font-size: 15px; }
    }
  `}</style>
</div>


{/* MANIFESTO SECTION */}
<div className="manifesto-section">


  {/* Main headline */}
  <h2 className="m-headline">
    "A sale is not completed until the
    <br />customer receives the result."
  </h2>


  {/* Brand statement */}
  <div className="brand-statement">
    <span className="brand-from">Sales God</span>
    <span className="brand-arrow">→</span>
    <span className="brand-to">Scale God</span>
  </div>

  {/* Supporting message */}
  <p className="m-sub">
    At Reflex Advisor, we believe execution and results are everything.
  </p>

  <style>{`
    .manifesto-section {
      position: relative;
      background: #000;
      color: #fff;
      padding: 100px 24px 110px;
      text-align: center;
      overflow: hidden;
      box-sizing: border-box;
      font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    }

    .manifesto-section::before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 400px;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(123,25,188,0.5), transparent);
    }

    .m-headline {
      font-size: 38px;
      font-weight: 700;
      line-height: 1.18;
      letter-spacing: -0.025em;
      color: rgba(255,255,255,0.92);
      margin: 0 auto 40px;
      max-width: 680px;
      font-style: italic;
      opacity: 0;
      animation: fadeUp 0.9s ease 0.2s forwards;
    }

    .brand-statement {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 18px;
      margin-bottom: 28px;
      opacity: 0;
      animation: fadeUp 0.9s ease 0.5s forwards;
    }

    .brand-from {
      font-size: 28px;
      font-weight: 700;
      letter-spacing: -0.02em;
      color: rgba(255,255,255,0.6);
    }

    .brand-arrow {
      font-size: 22px;
      color: #7b19bc;
    }

    .brand-to {
      font-size: 28px;
      font-weight: 700;
      letter-spacing: -0.02em;
      background: linear-gradient(90deg, #a855f7, #d18cf3, #7b19bc);
      background-size: 200% auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      animation: shimmer 3s linear 0.5s infinite;
    }

    @keyframes shimmer {
      0%   { background-position: 0% center; }
      100% { background-position: 200% center; }
    }

    .m-sub {
      font-size: 17px;
      font-weight: 400;
      color: rgba(255,255,255,0.75);
      letter-spacing: 0.01em;
      line-height: 1.6;
      margin: 0 auto;
      max-width: 460px;
      opacity: 0;
      animation: fadeUp 0.9s ease 0.8s forwards;
    }

    @keyframes fadeUp {
      from { opacity: 0; transform: translateY(18px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    @media (max-width: 768px) {
      .m-headline { font-size: 28px; }
      .brand-from, .brand-to { font-size: 22px; }
      .manifesto-section { padding: 72px 20px 80px; }
    }

    @media (max-width: 480px) {
      .m-headline { font-size: 22px; }
      .brand-from, .brand-to { font-size: 18px; }
      .brand-arrow { font-size: 16px; }
      .m-sub { font-size: 15px; }
    }
  `}</style>
</div>


{/* $47 WEBSITE OFFER SECTION */}
<div className="offer-wrap" id="offer-section">
  <div className="offer-inner">

    <div className="offer-badge">Website Launch Blast</div>

    <h2 className="offer-headline">
      Get your new updated website just for 47$ cant get better then this
          <br />
      <span className="offer-price-highlight">Ends July 20</span>
    </h2>

    <button className="offer-cta" onClick={() => setIsOfferModalOpen(true)}>
      Claim This Offer
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M3 8H13M13 8L8.5 3.5M13 8L8.5 12.5" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>

  </div>

  {/* OFFER MODAL */}
  {isOfferModalOpen && (
    <div className="offer-modal-backdrop" onClick={() => setIsOfferModalOpen(false)}>
      <div className="offer-modal-inner" onClick={(e) => e.stopPropagation()}>
        <button className="offer-modal-close" onClick={() => setIsOfferModalOpen(false)}>✕</button>

        <h3 className="offer-modal-title">Claim Your $47 Website</h3>
        <p className="offer-modal-sub">Fill in your details below and you'll be taken straight to secure payment.</p>

        <form className="offer-form" onSubmit={handleOfferSubmit}>
          <div className="offer-form-grid">
            <div className="offer-form-row">
              <label className="offer-form-label">Name</label>
              <input type="text" name="name" required className="offer-form-input"
                placeholder="Your full name" value={offerForm.name} onChange={handleOfferChange} />
            </div>
            <div className="offer-form-row">
              <label className="offer-form-label">Phone</label>
              <input type="tel" name="phone" required className="offer-form-input"
                placeholder="Your phone number" value={offerForm.phone} onChange={handleOfferChange} />
            </div>
          </div>

          <div className="offer-form-grid">
            <div className="offer-form-row">
              <label className="offer-form-label">Email</label>
              <input type="email" name="email" required className="offer-form-input"
                placeholder="you@company.com" value={offerForm.email} onChange={handleOfferChange} />
            </div>
            <div className="offer-form-row">
              <label className="offer-form-label">Website (if any)</label>
              <input type="text" name="website" className="offer-form-input"
                placeholder="https://yourcurrentsite.com" value={offerForm.website} onChange={handleOfferChange} />
            </div>
          </div>

          <div className="offer-form-row">
            <label className="offer-form-label">Note</label>
            <textarea name="note" className="offer-form-textarea"
              placeholder="Tell us a bit about what you need..." rows={2}
              value={offerForm.note} onChange={handleOfferChange} />
          </div>

          <button type="submit" className="offer-form-submit" disabled={offerSubmitting}>
            {offerSubmitting ? "Saving..." : "Continue to Payment →"}
          </button>
        </form>
      </div>
    </div>
   )}

  <style>{`
    .offer-wrap {
      position: relative;
      background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 25%, #cfcfcf 45%, #8a8a8a 65%, #2b2b2b 85%, #000000 100%);
      color: #0a0a0a;
      padding: 100px 24px 110px;
      text-align: center;
      overflow: hidden;
      box-sizing: border-box;
      font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      border-top: 1px solid #f0eaf8;
    }
    .offer-wrap::before {
      content: '';
      position: absolute;
      top: 0; left: 50%;
      transform: translateX(-50%);
      width: 420px; height: 1px;
      background: linear-gradient(90deg, transparent, rgba(123,25,188,0.35), transparent);
    }
    .offer-inner { max-width: 680px; margin: 0 auto; position: relative; z-index: 2; }
    .offer-badge {
      display: inline-block;
      font-size: 12px; font-weight: 700;
      letter-spacing: 0.12em; text-transform: uppercase;
      color: #7b19bc;
      background: rgba(123,25,188,0.08);
      border: 1px solid rgba(123,25,188,0.25);
      padding: 8px 18px; border-radius: 980px; margin-bottom: 28px;
    }
    .offer-headline {
      font-size: 42px; font-weight: 700;
      line-height: 1.12; letter-spacing: -0.03em;
      color: #0a0a0a; margin: 0 0 44px;
    }
    .offer-price-highlight {
      background: linear-gradient(90deg, #a855f7, #d18cf3, #7b19bc);
      background-size: 200% auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      animation: offer-shimmer 3s linear infinite;
    }
    @keyframes offer-shimmer {
      0%   { background-position: 0% center; }
      100% { background-position: 200% center; }
    }
    .offer-cta {
      display: inline-flex; align-items: center; gap: 10px;
      padding: 16px 36px; background: #7b19bc; color: #fff;
      font-size: 16px; font-weight: 600; letter-spacing: 0.01em;
      border: none; border-radius: 980px; cursor: pointer;
      transition: background 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
    }
    .offer-cta:hover {
      background: #9b24e8; transform: translateY(-2px);
      box-shadow: 0 8px 28px rgba(123,25,188,0.45);
    }
    .offer-modal-backdrop {
      position: fixed; inset: 0;
      background: rgba(0,0,0,0.75);
      backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px);
      display: flex; align-items: center; justify-content: center;
      z-index: 999; padding: 20px; box-sizing: border-box;
    }
    .offer-modal-inner {
      position: relative; width: 100%; max-width: 600px;
      max-height: 90vh; overflow-y: auto;
      background: #ffffff; border: 1px solid #ede8f5;
      border-radius: 18px; padding: 36px 32px 32px;
      box-shadow: 0 32px 80px rgba(0,0,0,0.25);
      box-sizing: border-box; text-align: left;
    }
    .offer-modal-close {
      position: absolute; top: 16px; right: 16px;
      background: #f3f1f6; color: #333; border: none;
      width: 32px; height: 32px; border-radius: 50%;
      font-size: 14px; cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      transition: background 0.2s ease;
    }
    .offer-modal-close:hover { background: #e8e4ee; }
    .offer-modal-title { font-size: 22px; font-weight: 700; color: #0a0a0a; margin: 0 0 8px; letter-spacing: -0.02em; }
    .offer-modal-sub { font-size: 14px; color: #666; line-height: 1.5; margin: 0 0 28px; }
    .offer-form { display: flex; flex-direction: column; gap: 16px; }
    .offer-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
    .offer-form-row { display: flex; flex-direction: column; gap: 6px; }
    .offer-form-label { font-size: 12px; font-weight: 600; letter-spacing: 0.04em; color: #666; text-transform: uppercase; }
    .offer-form-input, .offer-form-textarea {
      background: #faf9fb; border: 1px solid #e2dce9; border-radius: 8px;
      padding: 11px 14px; font-size: 14px; color: #0a0a0a;
      font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      outline: none; transition: border-color 0.2s ease, background 0.2s ease;
      box-sizing: border-box; width: 100%;
    }
    .offer-form-input::placeholder, .offer-form-textarea::placeholder { color: #aaa; }
    .offer-form-input:focus, .offer-form-textarea:focus { border-color: #7b19bc; background: #fff; }
    .offer-form-textarea { resize: vertical; font-family: inherit; }
    .offer-form-submit {
      margin-top: 10px; padding: 14px 24px;
      background: #7b19bc; color: #fff;
      font-size: 15px; font-weight: 600; border: none;
      border-radius: 980px; cursor: pointer;
      transition: background 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
    }
    .offer-form-submit:hover {
      background: #9b24e8; transform: translateY(-2px);
      box-shadow: 0 8px 28px rgba(123,25,188,0.45);
    }
    .offer-form-submit:disabled { opacity: 0.6; cursor: not-allowed; transform: none; box-shadow: none; }
    @media (max-width: 768px) {
      .offer-wrap { padding: 72px 20px 80px; }
      .offer-headline { font-size: 30px; }
      .offer-modal-inner { padding: 28px 22px 24px; }
      .offer-form-grid { grid-template-columns: 1fr; gap: 16px; }
    }
    @media (max-width: 480px) {
      .offer-headline { font-size: 24px; }
    }
  `}</style>
</div>


{/* TESTIMONIAL SECTION */}
<div className="ts-wrap">
  <div className="ts-inner">

    
    <h2 className="ts-headline">
      Work Less, Earn More, <span className="ts-headline-highlight">Scale Fast</span>
    </h2>
    <p className="ts-sub">Our clients have already achieved these results. You can get them too. Have a look at the reviews below. </p>

    <div className="ts-cards">
      {slides.map((slide, i) => (
        <div className="ts-card" key={i}>

          <div className="ts-card-top">
            <div className="ts-avatar">
              {slide.avatar
                ? <img src={slide.avatar} alt={slide.name} />
                : <span>{slide.initials}</span>
              }
            </div>
            <div className="ts-person-info">
              <div className="ts-person-row">
                <div>
                  <p className="ts-name">{slide.name}</p>
                  <p className="ts-role">{slide.role}</p>
                  <p className="ts-company">Company: {slide.company}</p>
                </div>
                <a href={slide.website} className="ts-visit" target="_blank" rel="noopener noreferrer">
                  Visit Client website →
                </a>
              </div>
              <p className="ts-stars">★★★★★</p>
            </div>
          </div>

          <p className="ts-quote">"{slide.quote}"</p>

        </div>
      ))}
    </div>

  </div>

  <style>{`
.ts-wrap {
  background: #ffffff;
  padding: 80px 24px 90px;
  border-top: 1px solid #ede8f5;
  border-bottom: 1px solid #ede8f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  box-sizing: border-box;
}

    .ts-inner {
      max-width: 720px;
      margin: 0 auto;
    }

    .ts-headline {
      font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      font-size: 44px;
      font-weight: 700;
      letter-spacing: -0.02em;
      line-height: 1.1;
      color: #0a0a0a;
      text-align: center;
      margin: 0 0 10px;
    }

    .ts-headline-highlight {
      background: linear-gradient(90deg, #a855f7, #d18cf3, #7b19bc);
      background-size: 200% auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      animation: ts-shimmer 3s linear infinite;
    }

    @keyframes ts-shimmer {
      0%   { background-position: 0% center; }
      100% { background-position: 200% center; }
    }

    .ts-sub {
      font-size: 18px;
      color: #000;
      text-align: center;
      margin: 0 0 48px;
    }

    .ts-cards {
      display: flex;
      flex-direction: column;
      gap: 0;
    }

    .ts-card {
      background: #ffffff;
      border: none;
      border-bottom: 1px solid #efefef;
      border-radius: 0;
      padding: 36px 0;
      display: flex;
      flex-direction: column;
    }

    .ts-card:first-child {
      border-top: 1px solid #efefef;
    }

    .ts-card-top {
      display: flex;
      align-items: flex-start;
      gap: 20px;
      margin-bottom: 20px;
    }

    .ts-avatar {
      width: 110px;
      height: 110px;
      border-radius: 12px;
      overflow: hidden;
      flex-shrink: 0;
      background: linear-gradient(135deg, #7b19bc, #9b24e8);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      font-weight: 700;
      color: #fff;
    }

    .ts-avatar img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
      transform: scale(1.4);
      transform-origin: top center;
    }

    .ts-person-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .ts-person-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
    }

    .ts-name {
      font-size: 17px;
      font-weight: 700;
      color: #0a0a0a;
      margin: 0 0 2px;
    }

    .ts-role {
      font-size: 14px;
      color: #444;
      margin: 0 0 2px;
      font-weight: 700;
    }

    .ts-company {
      font-size: 14px;
      color: #0a0a0a;
      margin: 0;
      font-weight: 700;
    }

    .ts-visit {
      font-size: 13px;
      font-weight: 600;
      color: #fff;
      text-decoration: none;
      white-space: nowrap;
      border: none;
      padding: 5px 14px;
      border-radius: 0;
      background: #0a0a0a;
      margin-top: 2px;
      flex-shrink: 0;
    }

    .ts-visit:hover {
      background: #333;
    }

    .ts-stars {
      font-size: 18px;
      color: #f5a623;
      margin: 8px 0 0;
      letter-spacing: 2px;
    }

    .ts-quote {
      font-size: 16px;
      color: #222;
      line-height: 1.75;
      margin: 0;
    }

    @media (max-width: 600px) {
      .ts-wrap { padding: 60px 16px 70px; }
      .ts-headline { font-size: 30px; }
      .ts-card { padding: 28px 0; }
      .ts-avatar { width: 80px; height: 80px; font-size: 20px; }
      .ts-name { font-size: 15px; }
      .ts-quote { font-size: 15px; }
    }
  `}</style>
</div>


{/* REFLEX REVIVAL SECTION */}
<div className="rr-section" id="reflex-revival">
  <div className="rr-inner">
    <h2 className="rr-headline">Meet Reflex Revival™ <br/> The System Bringing Lost Customers Back</h2>
  </div>

  <div className="rr-image-wrap">
    <img
      src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/revival2.png"
      alt="Reflex Revival system"
      className="rr-image"
    />
  </div>

  <div className="rr-inner rr-inner--bottom">
    <div className="rr-bottom">
      <p className="rr-tagline">Press one button and Reflex Revival™ follows up until they book, review, reply, or surrender.</p>
      <Link to="/revivalsystem" className="rr-btn">View details <span className="rr-btn-arrow">→</span></Link>
    </div>
  </div>

  <style>{`
    .rr-section {
      font-family: -apple-system, 'SF Pro Text', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      box-sizing: border-box;
      width: 100%;
      background: #f5f5f5;
    }
    .rr-inner {
      width: 100%;
      max-width: 1100px;
      margin: 0 auto;
      background: #f5f5f5;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 64px 40px 0;
      box-sizing: border-box;
    }
    .rr-inner--bottom {
      padding: 0 40px 48px;
    }
    .rr-headline {
      font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      font-size: 38px;
      font-weight: 800;
      letter-spacing: -0.035em;
      line-height: 1.08;
      color: #0a0a0a;
      margin: 0 0 20px 0;
      text-align: center;
      max-width: 780px;
    }
    .rr-image-wrap {
      width: 100%;
      margin-bottom: 20px;
      background: #f5f5f5;
    }
    .rr-image {
      display: block;
      width: 100%;
      height: auto;
    }
    .rr-bottom {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 22px;
    }
    .rr-tagline {
      font-size: 16px;
      font-weight: 500;
      color: #0a0a0a;
      line-height: 1.65;
      margin: 0;
      text-align: center;
      white-space: nowrap;
      max-width: none;
      
    }
    .rr-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #0a0a0a;
      color: #ffffff;
      font-family: -apple-system, 'SF Pro Text', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: -0.01em;
      text-decoration: none;
      padding: 14px 28px;
      border-radius: 100px;
      border: 1.5px solid rgba(255,255,255,0.15);
      box-shadow: 0 1px 2px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.08);
      transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
    }
    .rr-btn:hover {
      background: #222222;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.1);
    }
    .rr-btn:active {
      background: #000000;
      transform: translateY(0px);
      box-shadow: 0 1px 4px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.06);
    }
    .rr-btn-arrow {
      display: inline-block;
      transition: transform 0.18s ease;
      font-size: 15px;
    }
    .rr-btn:hover .rr-btn-arrow {
      transform: translateX(3px);
    }
    @media (max-width: 1024px) {
      .rr-inner { padding: 52px 32px 0; }
      .rr-inner--bottom { padding: 0 32px 36px; }
      .rr-headline { font-size: 34px; margin-bottom: 16px; }
      .rr-image-wrap { margin-bottom: 16px; }
    }
    @media (max-width: 768px) {
      .rr-inner { padding: 40px 24px 0; }
      .rr-inner--bottom { padding: 0 24px 28px; }
      .rr-headline { font-size: 26px; margin-bottom: 14px; }
      .rr-image-wrap { margin-bottom: 14px; }
      .rr-tagline { font-size: 16px; }
      .rr-bottom { gap: 16px; }
    }
    @media (max-width: 480px) {
      .rr-inner { padding: 32px 20px 0; }
      .rr-inner--bottom { padding: 0 20px 24px; }
      .rr-headline { font-size: 22px; margin-bottom: 12px; }
      .rr-image-wrap { margin-bottom: 12px; }
      .rr-tagline { font-size: 15px; }
      .rr-bottom { gap: 12px; }
      .rr-btn { font-size: 15px; padding: 12px 24px; }
    }
  `}</style>
</div>


{/* PILLARS SECTION */}
<div className="pillars-section">

  <div className="p-inner">

    <p className="p-eyebrow">What We Do</p>

    <h2 className="p-headline">
      We Take Service Businesses From<br />
      <span className="p-highlight">Struggling To Six Figures.</span>
    </h2>

    <p className="p-sub">
      Real Experts. Done For You. Starts Working Fast.
    </p>

    <div className="p-grid">

      <div className="p-card">
        <div className="p-card-number">01</div>
        <h3 className="p-card-title">Scale & Strategy</h3>
        <p className="p-card-tag">C-Suite Execution</p>
        <ul className="p-card-list">
          <li>See what's blocking your growth</li>
          <li>Fix what's costing you money</li>
          <li>Get a clear plan to hit your goal</li>
        </ul>
      </div>

      <div className="p-card">
        <div className="p-card-number">02</div>
        <h3 className="p-card-title">Lead Engine</h3>
        <p className="p-card-tag">Revenue Growth System</p>
        <ul className="p-card-list">
          <li>Get new customers every week</li>
          <li>Never lose a lead or follow-up</li>
          <li>Talk only to ready-to-pay leads</li>
        </ul>
      </div>

      <div className="p-card">
        <div className="p-card-number">03</div>
        <h3 className="p-card-title">Business Systems</h3>
        <p className="p-card-tag">Automation & Infrastructure</p>
        <ul className="p-card-list">
          <li>Bookings run themselves</li>
          <li>Turn visitors into customers</li>
          <li>Run business with less stress</li>
        </ul>
      </div>

    </div>

    <div className="p-closing">
      <p className="p-closing-text">
        Reflex Advisor is your <strong>done-for-you C-suite growth partner</strong> —
        we bring the strategy, the systems, and the execution.
      </p>
      <div className="p-closing-rule" />
      <p className="p-closing-note">You run the business. We build the machine that scales it.</p>
    </div>

  </div>

  <style>{`
    .pillars-section {
      position: relative;
      width: 100%;
      background: #181818;
      color: #fff;
      box-sizing: border-box;
      overflow: hidden;
      font-family: -apple-system, 'SF Pro Text', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    }

    .pillars-section::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(123,25,188,0.4), transparent);
    }

    .p-inner {
      max-width: 1080px;
      margin: 0 auto;
      padding: 110px 80px 120px;
      box-sizing: border-box;
    }

    .p-eyebrow {
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.2em;
      text-transform: uppercase;
      color: #7b19bc;
      margin: 0 0 20px;
      opacity: 0;
      animation: fadeUp 0.8s ease 0.1s forwards;
    }

    .p-headline {
      font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      font-size: 44px;
      font-weight: 700;
      letter-spacing: -0.03em;
      line-height: 1.1;
      color: rgba(255,255,255,0.95);
      margin: 0 0 20px;
      max-width: 680px;
      opacity: 0;
      animation: fadeUp 0.8s ease 0.2s forwards;
    }

    .p-highlight {
      background: linear-gradient(90deg, #ffffff, #c084fc, #a855f7, #7b19bc, #a855f7, #c084fc, #ffffff);
      background-size: 300% auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      animation: shimmer 4s linear infinite;
    }

    @keyframes shimmer {
      0%   { background-position: 0% center; }
      100% { background-position: 300% center; }
    }

    .p-sub {
      font-size: 16px;
      font-weight: 400;
      color: rgba(255,255,255,1);
      letter-spacing: 0.06em;
      text-transform: uppercase;
      margin: 0 0 72px;
      opacity: 0;
      animation: fadeUp 0.8s ease 0.35s forwards;
    }

    .p-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 0;
      margin: 0 0 80px;
      opacity: 0;
      animation: fadeUp 0.9s ease 0.5s forwards;
      border: 1px solid rgba(255,255,255,0.08);
      border-radius: 16px;
      overflow: hidden;
    }

    .p-card {
      background: transparent;
      padding: 44px 36px;
      text-align: left;
      position: relative;
      border-right: 1px solid rgba(255,255,255,0.08);
    }

    .p-card:last-child {
      border-right: none;
    }

    .p-card-number {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.15em;
      color: #7b19bc;
      margin-bottom: 20px;
    }

    .p-card-title {
      font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      font-size: 20px;
      font-weight: 700;
      letter-spacing: -0.02em;
      color: #fff;
      margin: 0 0 6px;
    }

    .p-card-tag {
      font-size: 12px;
      font-weight: 500;
      color: rgba(255,255,255,1);
      letter-spacing: 0.04em;
      margin: 0 0 28px;
      text-transform: uppercase;
    }

    .p-card-list {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .p-card-list li {
      font-size: 14px;
      font-weight: 400;
      color: rgba(255,255,255,1);
      line-height: 1.2;
      padding: 10px 0;
      border-bottom: 1px solid rgba(255,255,255,0.06);
      letter-spacing: 0.01em;
    }

    .p-card-list li:last-child {
      border-bottom: none;
    }

    .p-card-list li::before {
      content: '—';
      color: #7b19bc;
      margin-right: 10px;
      font-weight: 700;
    }

    .p-closing {
      max-width: 580px;
      opacity: 0;
      animation: fadeUp 0.8s ease 0.7s forwards;
    }

    .p-closing-text {
      font-size: 17px;
      font-weight: 400;
      color: rgba(255,255,255,1);
      line-height: 1.65;
      margin: 0 0 28px;
    }

    .p-closing-text strong {
      color: #fff;
      font-weight: 600;
    }

    .p-closing-rule {
      width: 48px;
      height: 2px;
      background: #7b19bc;
      margin: 0 0 24px;
      border-radius: 2px;
    }

    .p-closing-note {
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: rgba(255,255,255,1);
      margin: 0;
    }

    @keyframes fadeUp {
      from { opacity: 0; transform: translateY(18px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    @media (max-width: 900px) {
      .p-inner { padding: 80px 32px 90px; }
      .p-grid {
        grid-template-columns: 1fr;
        border-radius: 14px;
      }
      .p-card {
        border-right: none;
        border-bottom: 1px solid rgba(255,255,255,0.08);
      }
      .p-card:last-child { border-bottom: none; }
      .p-headline { font-size: 32px; }
    }

    @media (max-width: 480px) {
      .p-inner { padding: 72px 20px 80px; }
      .p-headline { font-size: 26px; }
      .p-card { padding: 32px 24px; }
      .p-closing-text { font-size: 15px; }
    }
  `}</style>
</div>


{/* SPECIALIZED SECTION */}
<div className="sp-wrap">

<div className="sp-img-wrap">
    <img src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/person.png" alt="Specialist" />
  </div>

  <div className="sp-inner">
    <h2 className="sp-eyebrow">You Relax, We Scale You.</h2>
    <h2 className="sp-h">
    We are highly focused only on the{' '}
    <span className="sp-h-highlight">service based industry.</span>
  
    </h2>
    <div className="sp-divider" />
    <p className="sp-body">We help service based companies get more commercial contracts from premium, high-paying clients. On top of that, we help companies scale from 5-figure to 6-figure through our complete executive team.</p>
  </div>

  <style>{`
    .sp-wrap {
      display: flex;
      align-items: stretch;
      font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      box-sizing: border-box;
      background: #fff;
      overflow: hidden;
    }
    .sp-inner {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      gap: 20px;
      padding: 80px 48px;
      justify-content: center;
      background: #fff;
    }
    .sp-eyebrow {
      font-size: 18px;
      font-style: italic;
      font-weight: 500;
      letter-spacing: 0.16em;
      text-transform: uppercase;
      color: #000000;
      margin: 0;
    }
    
    .sp-h {
  font-size: 38px;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: #0a0a0a;
  margin: 0;
}

.sp-h-highlight {
  background: linear-gradient(90deg, #a855f7, #d18cf3, #7b19bc);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: sp-shimmer 3s linear infinite;
}

@keyframes sp-shimmer {
  0%   { background-position: 0% center; }
  100% { background-position: 200% center; }
}

    }
    .sp-divider {
      width: 40px;
      height: 2px;
      background: #7b19bc;
    }
    .sp-body {
      font-size: 16px;
      color: #000000;
      line-height: 1.75;
      margin: 0;
      font-weight: 500;
    }
    .sp-img-wrap {
      flex: 0 0 42%;
      max-width: 42%;s
      overflow: hidden;
      display: flex;
      align-items: stretch;
    }
    .sp-img-wrap img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
      display: block;
    }
    @media (max-width: 768px) {
      .sp-wrap { flex-direction: column; }
      .sp-inner { padding: 50px 24px; }
      .sp-img-wrap { flex: none; max-width: 100%; height: 380px; }
      .sp-h { font-size: 26px; }
      .sp-body { font-size: 15px; }
    }
  `}</style>
</div>


{/* FEATURED SECTION */}
<div className="featured-section">
  <div className="featured-inner">

    <p className="feat-eyebrow">As Featured On</p>

    <h2 className="feat-headline">
      Trusted by Clients.<br />
      <span className="feat-highlight">Recognized by the Industry.</span>
    </h2>

    <p className="feat-sub">
      Reflex Advisor has been independently featured and reviewed across leading business platforms — here's what they found.
    </p>

    <div className="feat-grid">

      <a
        href="https://ariusbusiness.com/company/reflex-advisor"
        target="_blank"
        rel="noopener noreferrer"
        className="feat-card feat-card-link"
      >
        <div className="feat-card-top">
          <span className="feat-logo-badge">Arius</span>
          <div className="feat-stars">
            {[1, 2, 3, 4, 5].map(i => (
              <div className="feat-star" key={i} />
            ))}
          </div>
        </div>
        <p className="feat-platform-name">Arius Business</p>
        <p className="feat-snippet">
          "Exceptional service quality and outstanding customer experience in the growth marketing space."
        </p>
      </a>

      <a
        href="https://podstatus.com/podcasts/reflex-advisor-junk-removal-growth-system-1381602"
        target="_blank"
        rel="noopener noreferrer"
        className="feat-card feat-card-link"
      >
        <div className="feat-card-top">
          <span className="feat-logo-badge">Pod</span>
          <div className="feat-stars">
            {[1, 2, 3, 4, 5].map(i => (
              <div className="feat-star" key={i} />
            ))}
          </div>
        </div>
        <p className="feat-platform-name">PodStatus</p>
        <p className="feat-snippet">
          "Officially listed and indexed — recognized across top podcast discovery platforms."
        </p>
      </a>

      <a
        href="https://www.iheart.com/podcast/1333-reflex-advisor-junk-remov-334620563/"
        target="_blank"
        rel="noopener noreferrer"
        className="feat-card feat-card-link"
      >
        <div className="feat-card-top">
          <span className="feat-logo-badge">iHeart</span>
          <div className="feat-stars">
            {[1, 2, 3, 4, 5].map(i => (
              <div className="feat-star" key={i} />
            ))}
          </div>
        </div>
        <p className="feat-platform-name">iHeartRadio</p>
        <p className="feat-snippet">
          "Featured on iHeartRadio — one of the world's largest audio networks reaching millions of listeners."
        </p>
      </a>

    </div>

  </div>

  <style>{`
    .featured-section {
      background: #0a0a0a;
      padding: 100px 24px 110px;
      text-align: center;
      font-family: -apple-system, 'SF Pro Text', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      border-top: 1px solid rgba(123,25,188,0.15);
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
    }

    .featured-section::before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 500px;
      height: 1px;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(123,25,188,0.5),
        transparent
      );
    }

    .featured-inner {
      max-width: 820px;
      margin: 0 auto;
    }

    .feat-eyebrow {
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.2em;
      text-transform: uppercase;
      color: #7b19bc;
      margin: 0 0 20px;
    }

    .feat-headline {
      font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
      font-size: 42px;
      font-weight: 700;
      line-height: 1.1;
      letter-spacing: -0.03em;
      color: rgba(255,255,255,0.93);
      margin: 0 0 16px;
    }

    .feat-highlight {
      background: linear-gradient(90deg, #a855f7, #d18cf3, #7b19bc);
      background-size: 200% auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      animation: shimmer 3s linear infinite;
    }

    .feat-sub {
      font-size: 17px;
      color: rgba(255,255,255,0.5);
      line-height: 1.65;
      margin: 0 auto 56px;
      max-width: 500px;
    }

    .feat-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      border: 1px solid rgba(255,255,255,0.08);
      border-radius: 18px;
      overflow: hidden;
    }

    .feat-card {
      padding: 36px 28px;
      border-right: 1px solid rgba(255,255,255,0.08);
      text-align: left;
    }

    .feat-card:last-child {
      border-right: none;
    }

    .feat-card-link {
      display: block;
      text-decoration: none;
      transition: background 0.25s ease;
    }

    .feat-card-link:hover {
      background: rgba(123,25,188,0.08);
    }

    .feat-card-top {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 14px;
    }

    .feat-logo-badge {
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      color: #7b19bc;
      border: 1px solid rgba(123,25,188,0.3);
      padding: 4px 8px;
      border-radius: 5px;
    }

    .feat-stars {
      display: flex;
      gap: 3px;
    }

    .feat-star {
      width: 13px;
      height: 13px;
      background: #ffba00;
      clip-path: polygon(
        50% 0%,
        61% 35%,
        98% 35%,
        68% 57%,
        79% 91%,
        50% 70%,
        21% 91%,
        32% 57%,
        2% 35%,
        39% 35%
      );
    }

    .feat-platform-name {
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      letter-spacing: -0.02em;
      margin: 0 0 6px;
    }

    .feat-snippet {
      font-size: 14px;
      color: rgba(255,255,255,0.5);
      line-height: 1.6;
      font-style: italic;
      margin: 0;
    }

    @keyframes shimmer {
      from {
        background-position: 0% center;
      }
      to {
        background-position: 200% center;
      }
    }

    @media (max-width: 768px) {
      .featured-section {
        padding: 72px 20px 80px;
      }

      .feat-grid {
        grid-template-columns: 1fr;
      }

      .feat-card {
        border-right: none;
        border-bottom: 1px solid rgba(255,255,255,0.08);
      }

      .feat-card:last-child {
        border-bottom: none;
      }

      .feat-headline {
        font-size: 28px;
      }

      .feat-sub {
        font-size: 15px;
      }
    }

    @media (max-width: 480px) {
      .feat-headline {
        font-size: 22px;
      }
    }
  `}</style>
</div>


{/* SISTER COMPANIES SECTION */}
<div style={{
  background: '#fff',
  padding: '80px 24px',
  textAlign: 'center',
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif",
  borderTop: '1px solid #f0eaf8'
}}>
  <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#7b19bc', margin: '0 0 16px' }}>Our Sister Companies</p>
  <h2 style={{ fontSize: 36, fontWeight: 700, color: '#0a0a0a', margin: '0 0 48px', letterSpacing: '-0.02em' }}>Part of the Reflex Family</h2>

  <div style={{ display: 'flex', justifyContent: 'center', gap: 24, flexWrap: 'wrap', maxWidth: 780, margin: '0 auto' }}>

    {/* Sister 1 */}
    <div style={{ flex: '1', minWidth: 280, maxWidth: 340, border: '1px solid #ede8f5', borderRadius: 16, padding: '36px 28px' }}>
      <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#7b19bc', margin: '0 0 12px' }}>Junk Removal</p>
      <h3 style={{ fontSize: 22, fontWeight: 700, color: '#0a0a0a', margin: '0 0 10px' }}>Reflex Junk</h3>
      <p style={{ fontSize: 15, color: '#555', lineHeight: 1.65, margin: '0 0 24px' }}>We specialize in scaling junk removal businesses, more bookings, more revenue.</p>
      <a href="https://reflexjunk.online/" target="_blank" rel="noopener noreferrer"
        style={{ display: 'inline-block', padding: '11px 26px', background: '#7b19bc', color: '#fff', borderRadius: 980, fontSize: 14, fontWeight: 600, textDecoration: 'none' }}>
        Visit Reflex Junk →
      </a>
    </div>

    {/* Sister 2 */}
    <div style={{ flex: '1', minWidth: 280, maxWidth: 340, border: '1px solid #ede8f5', borderRadius: 16, padding: '36px 28px' }}>
      <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#7b19bc', margin: '0 0 12px' }}>Roofing</p>
      <h3 style={{ fontSize: 22, fontWeight: 700, color: '#0a0a0a', margin: '0 0 10px' }}>Reflex Roofer</h3>
      <p style={{ fontSize: 15, color: '#555', lineHeight: 1.65, margin: '0 0 24px' }}> We specialize in scaling roofing businesses, connecting roofers with high-paying contracts.</p>
      <a href="https://reflexroofer.online/" target="_blank" rel="noopener noreferrer"
        style={{ display: 'inline-block', padding: '11px 26px', background: '#7b19bc', color: '#fff', borderRadius: 980, fontSize: 14, fontWeight: 600, textDecoration: 'none' }}>
        Visit Reflex Roofer →
      </a>
    </div>

  </div>
</div>

    </React.Fragment>
  );
}